import { ImageName } from "@mcleod/images";
import { AutogenLayoutCommissionsProcessing } from "./autogen/AutogenLayoutCommissionsProcessing";
import {
    ClickEvent, CrudDecorator, DataSourceAction, DataSourceExecutionEvent, DataSourceMode, Layout, MultiButton, Table
} from "@mcleod/components";
import { ModelRow, ModelRowType, UrlUtil } from "@mcleod/core";
import { PendingCommissions } from "./PendingCommissions";
import { FilterPanel } from "@mcleod/dispatch";

export interface CommissionsProcessingTabLayout extends Layout {
    tableCommissionsProcessing: Table;
    getLayoutBaseFilter: (row: ModelRow) => boolean;
    filterPanel: FilterPanel;
}

export class CommissionsProcessing extends AutogenLayoutCommissionsProcessing {
    onLoad(): void | Promise<void> {
        const urlProp = UrlUtil.getPropsFromUrl(window.location.search);
        if (urlProp != null && urlProp.id != null) {
            this.mainDataSource.search({ ids: urlProp.id });
        }
        this.tabProcess.select();
        this.layoutheaderCommissionsProcessing.addRightTools(this.generateAddCommissionsButton());
        this.layoutCommissionsProcessingProcess.getPayees = this.getGroupByPayees.bind(this);
        this.layoutCommissionsProcessingVoid.getPayees = this.getGroupByPayees.bind(this);
    }

    sourceCommissionAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() == DataSourceAction.SEARCH) {
            this.layoutGroupBy.initialize(this.tabsetCommissionsProcessing);
        }
    }

    private generateAddCommissionsButton() {
        const multiButton = new MultiButton({
            id: "addCommissionsButton",
            rowBreak: false,
            color: "primary.reverse",
            backgroundColor: "primary",
            imageName: ImageName.add,
            width: 160,
            marginRight: 25
        });
        multiButton.primaryButton.setProps({
            id: "buttonAddPendingCommissions",
            caption: "Add Commissions",
            onClick: (event) => this.buttonAddCommissionsOnClick(event)
        });
        return multiButton;
    }

    buttonAddCommissionsOnClick(event: ClickEvent) {
        const layout = Layout.getLayout("lme/settlement/commissions/PendingCommissions") as PendingCommissions;
        layout.ensureLoaded().then(() => {
            layout.mainDataSource.addAfterExecutionListener((event: DataSourceExecutionEvent) => {
                if (event.getAction() == DataSourceAction.ADD) {
                    this.mainDataSource.search(this.mainDataSource.lastSearch);
                }
            });
        });
        const crudPanel = new CrudDecorator({
            layout: layout,
            mode: DataSourceMode.ADD,
            headerProps: {
                showClose: true,
                showSaveAndClose: true
            }
        });
        crudPanel.slideIn({ speed: 200 });
    }

    getGroupByPayees() :ModelRow[]{
        return this.layoutGroupBy.tableGroupBy.selectedRows.map((tableRow) => {
            const lookupDataRow = new ModelRow("lme/settlement/officepayroll/off-payee");
            const data = tableRow.data as ModelRow;
            lookupDataRow.set("id", tableRow.data.get("payee_id"))
            lookupDataRow.set("payee.name", data.getLookupModelData("payee_id")[0].get("name"));
            lookupDataRow.type = ModelRowType.LOOKUP_MODEL_DATA;
            return lookupDataRow;
        });
    }
}
